import { openNotification } from "../Components/Notification";
import { EnquiryDto } from "../Dto/Enquiry.dto";
import apiClient from "./api.client.service";

class EnquiryService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async sendEnquiry(payload: EnquiryDto) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/admin/enquiry`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if(response.data){
        openNotification("success", "Submited", "Our team will contact you soon");
        return true;
      }
    } catch (err) {
      console.error("🚀 ~ EnquiryService ~ sendEnquiry ~ err:", err);
      openNotification("error", "Try Again", "Failed to send");
      return false;
    }
  }
}

const enquiryService = new EnquiryService();
export default enquiryService;
